<template>
  <b-row align-v="center" class="justify-content-start m-1" no-gutters>

    <b-col md="auto" class="ml-4">
      <span>이메일</span>
    </b-col>

    <b-col cols="3" class="ml-4">
      <b-input-group size="sm">
        <b-form-input v-model="data.email"></b-form-input>
      </b-input-group>
    </b-col>
    <b-col md="auto" class="ml-3">
      <b-button variant="outline-success" class="mb-2 mr-sm-3 mb-sm-0" size="xs"  @click.prevent="deleteEmail">삭제</b-button>
    </b-col>


  </b-row>

</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        // params: {
        //   id: null
        // },
      }
    },

    mounted() {
    },

    methods: {
      deleteEmail() {
        this.$emit('deleteNumber', this.data.id)
      }
    }
  }
</script>
